import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=7f6405f7&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6405f7')) {
      api.createRecord('7f6405f7', component.options)
    } else {
      api.reload('7f6405f7', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=7f6405f7&", function () {
      api.rerender('7f6405f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/SearchBar.vue"
export default component.exports